import { TenantCreate } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { useMutationWithErrorHandler } from "@nens/ranalib";

import { useInvalidateTenantListQuery, useUpdateTenantQueries } from "@/queries/query-tenant";

export const useCreateTenant = () => {
  const updateTenantQueries = useUpdateTenantQueries();
  const invalidateTenantListQuery = useInvalidateTenantListQuery();
  return useMutationWithErrorHandler(async (tenantCreate: TenantCreate) => {
    const result = await getRanaApiV1().TenantsApi.tenantCreate({ tenantCreate });
    updateTenantQueries(result.id, result);
    invalidateTenantListQuery();
    return result;
  });
};
